import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js";
import "../../plugins/chartJsBarChartBackgroundPlugin";
import { format, getPropertyValue, hydrateRoute } from "../../../utils";
import { useGlobalValue } from "../../../state/GlobalProvider";
import NoResults from "../../NoResults/NoResults";
import styles from "./PieChart.module.sass";
import "chartjs-plugin-labels";
import { setParsedCurrency } from "../../../utils/format";
Chart.defaults.global.plugins.labels = false;
const truncateString = value => {
  if ((value ? value : "").length > 20) {
    return value.substring(value, 20) + "...";
  } else {
    return value;
  }
};
const renderChart = (canvas, cData, chartColors, link, currencyType, params, currency) => {
  const chartData = cData && cData.length ? cData : [];
  const ctx = canvas.getContext("2d");
  let availableColors = chartColors;
  const chart = new Chart(ctx, {
    type: "pie",
    data: {
      labels: (chartData || [{}]).map(elem => elem.name),
      datasets: [{
        backgroundColor: availableColors,
        borderColor: "white",
        data: (chartData || [{}]).map(elem => elem.y)
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      rotation: 0,
      legend: {
        display: false
      },
      layout: {
        padding: 32
      },
      hover: {
        mode: "nearest",
        animationDuration: 0,
        onHover: (e, chartElements) => {
          e.target.style.cursor = chartElements[0] ? "pointer" : "default";
        }
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            return data.labels[tooltipItem.index];
          },
          afterLabel: function (tooltipItem, data) {
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return format(value, "short", currency.currency, 2, currency.locale);
          }
        },
        displayColors: false,
        backgroundColor: getPropertyValue("--pie-tooltip--background-color").trim(),
        borderColor: getPropertyValue("--pie-tooltip--background-color").trim(),
        borderWidth: 1,
        cornerRadius: 0
      },
      onClick: evt => {
        const activePoints = chart.getElementAtEvent(evt);
        const tooltipItem = activePoints[0] || {};
        const key = chartData && chartData[tooltipItem._index] && chartData[tooltipItem._index].key ? chartData[tooltipItem._index].key : undefined;
        if (key) {
          window.location.href = hydrateRoute(link, params) + key;
        }
      },
      plugins: {
        labels: {
          render: function (context) {
            const index = context.index;
            const value = chartData[index].x;
            const name = context.label;
            return `${truncateString(name)}: ${Math.round(value * 100) / 100}%`;
          },
          position: "outside",
          fontStyle: "normal",
          fontColor: getPropertyValue("--chartjs-text-color").trim(),
          fontFamily: "Inter",
          fontSize: 12,
          lineHeight: 16,
          fontWeight: 400
        }
      }
    }
  });
  return chart;
};
const PieChart = ({
  data,
  link,
  chartColor,
  currencyType,
  dynamicCurrency
}) => {
  const [currency, setCurrency] = useState({
    locale: undefined,
    currency: false
  });
  const {
    theme,
    params
  } = useGlobalValue();
  const {
    colors = {}
  } = theme || {};
  const defaultColors = [];
  defaultColors.push(getPropertyValue(`--pie-chart-first-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-second-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-third-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-fourth-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-fifth-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-sixth-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-seventh-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-eigth-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-ninth-color-${chartColor ? "orange" : "cyan"}`).trim());
  defaultColors.push(getPropertyValue(`--pie-chart-tenth-color-${chartColor ? "orange" : "cyan"}`).trim());
  const canvas = useRef(null);
  useEffect(() => {
    setParsedCurrency(currencyType, dynamicCurrency, setCurrency);
  }, [dynamicCurrency, currencyType]);
  useEffect(() => {
    const chart = canvas.current && data && renderChart(canvas.current, data || {}, defaultColors, link, currencyType, params, currency);
    return () => {
      chart && chart.destroy();
    };
  }, [canvas, data, defaultColors, colors, currency]);
  const hasResults = Object.keys(data || {}).length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["root"]
  }, hasResults ? /*#__PURE__*/React.createElement("canvas", {
    ref: canvas
  }) : /*#__PURE__*/React.createElement(NoResults, {
    className: styles["root-result"]
  }));
};
export default PieChart;